    /**
     * Room Visualization Feature
     * Handles the visualization modal and API integration
     * VERSION: 2.0 - Event Listener Fix
     */

    (function() {
    'use strict';

    // Configuration
    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
    const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
    const REQUEST_TIMEOUT = 120000; // 2 minutes

    class RoomVisualization {
        constructor() {
        this.modal = null;
        this.currentStep = 'upload';
        this.uploadedFile = null;
        this.generatedImage = null;
        this.productVariantId = null;
        this.productId = null;
        this.workerUrl = null;
        this.productImageUrl = null;
        this.isOpening = false;
        this.isClosing = false;
        this.isResetting = false;
        this.previouslyFocusedElement = null;
        this.initialized = false;
        this.modalOpenedAt = 0; // Timestamp when modal was opened
        
        // Store bound handlers to prevent duplicate listeners
        this.boundHandlers = {
            buttonClick: null,
            escKey: null,
            fileChange: null,
            privacyChange: null,
            variantChange: null,
            createClick: null,
            addToCartClick: null
        };
        
        this.init();
        }

        init() {
        // Prevent multiple initializations
        if (this.initialized) {
            return;
        }
        
        // Check if visualization is enabled
        const button = document.querySelector('.product-visualization-button');
        if (!button) {
            return;
        }

        // Get worker URL from theme settings
        const workerUrlMeta = document.querySelector('meta[name="visualizer-worker-url"]');
        if (!workerUrlMeta || !workerUrlMeta.content) {
            console.warn('Visualization: Worker URL not configured');
            return;
        }

        this.workerUrl = workerUrlMeta.content;
        this.productId = button.dataset.productId;
        this.productVariantId = button.dataset.productVariantId;
        
        // Normalize URL - ensure it has a protocol
        let imageUrl = button.dataset.productImageUrl;
        if (imageUrl && imageUrl.startsWith('//')) {
            imageUrl = 'https:' + imageUrl;
        }
        this.productImageUrl = imageUrl;
        this.productImageUrls = imageUrl ? [imageUrl] : [];

        // Keep the visualization and cart action aligned with the selected variant.
        this.syncSelectedVariant();

        // Render modal
        this.renderModal();

        // Bind events
        this.bindEvents();
        
        this.initialized = true;
        }

        renderModal() {
        // Check if modal already exists
        const existingModal = document.getElementById('visualization-modal');
        if (existingModal) {
            this.modal = existingModal;
            return;
        }

        // Prevent multiple renders
        if (this.modal) {
            return;
        }

        // Create modal container
        const modalContainer = document.createElement('div');
        modalContainer.innerHTML = `
            <div
            id="visualization-modal"
            class="visualization-modal"
            role="dialog"
            aria-modal="true"
            aria-hidden="true"
            aria-labelledby="visualization-modal-title"
            >
            <div class="visualization-modal__overlay" data-modal-close></div>
            <div class="visualization-modal__content">
                <button
                type="button"
                class="visualization-modal__close"
                aria-label="Затвори"
                data-modal-close
                >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>

                <div class="visualization-modal__step visualization-modal__step--upload" data-step="upload">
                <h2 id="visualization-modal-title" class="visualization-modal__title" data-upload-title>Качи снимка и виж избраната мебел в твоята стая</h2>
                <p class="visualization-modal__helper-text visualization-modal__upload-only">JPG/PNG, максимум 10MB</p>
                <p class="visualization-modal__helper-text">Снимката се използва само за визуализацията и не се съхранява от Аким Стар.</p>
                <div class="visualization-modal__tips visualization-modal__upload-only">
                  <p class="visualization-modal__tips-title">За най-добър резултат:</p>
                  <ul class="visualization-modal__tips-list">
                    <li>Снимайте от ъгъл, който показва ясно мястото за новата мебел</li>
                    <li>Снимайте при добро осветление</li>
                    <li>Избягвайте снимки с лошо качество</li>
                    <li>Включете пода и пространството около мястото, за да определим правилния размер и позиция</li>
                  </ul>
                </div>
                
                <div class="visualization-modal__upload-area visualization-modal__upload-only" data-upload-area>
                    <input
                    type="file"
                    id="visualization-file-input"
                    class="visualization-modal__file-input"
                    accept="image/jpeg,image/jpg,image/png"
                    data-file-input
                    >
                    <label for="visualization-file-input" class="visualization-modal__dropzone">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="visualization-modal__upload-icon">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="visualization-modal__dropzone-text">Избери файл или пусни тук</span>
                    </label>
                </div>

                <div class="visualization-modal__preview" data-upload-preview style="display: none;">
                    <img src="" alt="Преглед на помещението" class="visualization-modal__preview-image" data-preview-image width="800" height="600">
                </div>

                <button type="button" class="visualization-modal__change-photo" data-change-photo>
                    Смени снимката
                </button>

                <div class="visualization-modal__error" data-upload-error role="alert" style="display: none;"></div>

                <button
                    type="button"
                    class="btn btn-primary visualization-modal__create-button"
                    data-create-button
                    disabled
                >
                    Създай визуализация
                </button>
                </div>

                <div class="visualization-modal__step visualization-modal__step--loading" data-step="loading" style="display: none;">
                <div class="visualization-modal__loader">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="visualization-modal__spinner">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416" opacity="0.3"/>
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="23.562" transform="rotate(-90 12 12)"/>
                    </svg>
                </div>
                <p class="visualization-modal__loading-text">Генерираме вашата визуализация...</p>
                </div>

                <div class="visualization-modal__step visualization-modal__step--result" data-step="result" style="display: none;">
                <div class="visualization-modal__result-image-wrapper">
                    <img src="" alt="Резултат от визуализацията" class="visualization-modal__result-image" data-result-image width="800" height="600">
                </div>
                <button
                    type="button"
                    class="btn btn-primary visualization-modal__add-to-cart-button"
                    data-add-to-cart-button
                >
                    Добави в количка
                </button>
                <div class="visualization-modal__error" data-result-error role="alert" style="display: none;"></div>
                </div>
            </div>
            </div>
        `;

        document.body.appendChild(modalContainer);
        this.modal = document.getElementById('visualization-modal');
        }

        bindEvents() {
        // Open modal button - REMOVE old listener first
        const button = document.querySelector('.product-visualization-button');
        if (button) {
            if (this.boundHandlers.buttonClick) {
            button.removeEventListener('click', this.boundHandlers.buttonClick);
            }
            
            this.boundHandlers.buttonClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            // Extra guard: only open if not already opening
            if (!this.isOpening && !this.isOpen()) {
                this.openModal();
            }
            };
            
            button.addEventListener('click', this.boundHandlers.buttonClick);
        }

        // Close modal
        const closeButtons = this.modal?.querySelectorAll('[data-modal-close]');
        if (closeButtons) {
            closeButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.closeModal();
            });
            });
        }

        // ESC key - REMOVE old listener first
        if (this.boundHandlers.escKey) {
            document.removeEventListener('keydown', this.boundHandlers.escKey);
        }
        
        this.boundHandlers.escKey = (e) => {
            if (e.key === 'Escape' && this.isOpen()) {
            this.closeModal();
            }
        };
        
        document.addEventListener('keydown', this.boundHandlers.escKey);

        // File input
        const fileInput = this.modal?.querySelector('[data-file-input]');
        if (fileInput) {
            if (this.boundHandlers.fileChange) {
            fileInput.removeEventListener('change', this.boundHandlers.fileChange);
            }
            
            this.boundHandlers.fileChange = (e) => {
            const now = Date.now();
            const timeSinceOpen = now - this.modalOpenedAt;
            
            // CRITICAL: Ignore file changes for 2 seconds after modal opens
            // This prevents browser auto-fill/cached file from triggering
            if (timeSinceOpen < 2000) {
                e.target.value = ''; // Clear it
                return;
            }
            
            // Also ignore if actively resetting
            if (this.isResetting || this.isOpening) {
                e.target.value = ''; // Clear it
                return;
            }
            
            this.handleFileSelect(e);
            };
            fileInput.addEventListener('change', this.boundHandlers.fileChange);
        }

        const changePhotoButton = this.modal?.querySelector('[data-change-photo]');
        if (changePhotoButton && fileInput) {
            this.boundHandlers.changePhotoClick = () => fileInput.click();
            changePhotoButton.addEventListener('click', this.boundHandlers.changePhotoClick);
        }

        this.boundHandlers.variantChange = (event) => {
            if (event.target.matches('form[id^="product-form-"] input[name="id"], product-form input[name="id"]')) {
                this.syncSelectedVariant();
            }
        };
        document.addEventListener('change', this.boundHandlers.variantChange);

        // Drag and drop
        const dropzone = this.modal?.querySelector('[data-upload-area]');
        if (dropzone) {
            dropzone.addEventListener('dragover', (e) => {
            e.preventDefault();
            dropzone.classList.add('is-dragover');
            });
            dropzone.addEventListener('dragleave', () => {
            dropzone.classList.remove('is-dragover');
            });
            dropzone.addEventListener('drop', (e) => {
            e.preventDefault();
            dropzone.classList.remove('is-dragover');
            const file = e.dataTransfer.files[0];
            if (file) {
                this.handleFile(file);
            }
            });
        }

        // Create visualization button
        const createButton = this.modal?.querySelector('[data-create-button]');
        if (createButton) {
            if (this.boundHandlers.createClick) {
            createButton.removeEventListener('click', this.boundHandlers.createClick);
            }
            
            this.boundHandlers.createClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // Extra guard: don't run if button is disabled OR no file
            if (createButton.disabled || !this.uploadedFile) {
                return;
            }
            
            this.createVisualization();
            };
            createButton.addEventListener('click', this.boundHandlers.createClick);
        }

        // Add to cart button
        const addToCartButton = this.modal?.querySelector('[data-add-to-cart-button]');
        if (addToCartButton) {
            if (this.boundHandlers.addToCartClick) {
            addToCartButton.removeEventListener('click', this.boundHandlers.addToCartClick);
            }
            
            this.boundHandlers.addToCartClick = () => this.addToCart();
            addToCartButton.addEventListener('click', this.boundHandlers.addToCartClick);
        }
        }

        openModal() {
        if (!this.modal) {
            return;
        }
        
        // Prevent any re-entry
        if (this.isOpening) {
            return;
        }
        if (this.modal.classList.contains('is-open')) {
            return;
        }
        
        // Set flag IMMEDIATELY before ANY other operation
        this.isOpening = true;
        this.syncSelectedVariant();
        
        try {
            this.modal.setAttribute('aria-hidden', 'false');
            this.modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            
            // Store timestamp to ignore file changes for 2 seconds
            this.modalOpenedAt = Date.now();
            
            // Store previously focused element
            this.previouslyFocusedElement = document.activeElement;
            
            // Call reset in next frame to break stack
            requestAnimationFrame(() => {
            this.resetToUpload();
            });
            
        } catch (err) {
            console.error('❌ Error in openModal:', err);
        } finally {
            // Reset flag after a longer delay
            setTimeout(() => {
            this.isOpening = false;
            }, 500);
        }
        }

        closeModal() {
        if (!this.modal) return;
        
        // Prevent recursive closes
        if (this.isClosing || !this.modal.classList.contains('is-open')) return;
        
        this.isClosing = true;
        
        this.modal.setAttribute('aria-hidden', 'true');
        this.modal.classList.remove('is-open');
        document.body.style.overflow = '';
        
        // Return focus safely
        setTimeout(() => {
            try {
            if (this.previouslyFocusedElement && typeof this.previouslyFocusedElement.focus === 'function') {
                this.previouslyFocusedElement.focus();
            }
            } catch (e) {
            // Ignore focus errors
            }
            this.previouslyFocusedElement = null;
        }, 50);
        
        // Reset state
        setTimeout(() => {
            this.resetToUpload();
            this.isClosing = false;
        }, 100);
        }

        isOpen() {
        return this.modal?.classList.contains('is-open');
        }

        resetToUpload() {
        // Prevent recursive resets
        if (this.isResetting) {
            return;
        }
        
        this.isResetting = true;
        
        // IMMEDIATELY clear state - don't wait for RAF
        this.currentStep = 'upload';
        this.uploadedFile = null;
        this.generatedImage = null;
        
        // IMMEDIATELY clear and disable file input to prevent auto-fill
        const fileInput = this.modal?.querySelector('[data-file-input]');
        if (fileInput) {
            fileInput.value = '';
        }
        
        // IMMEDIATELY disable create button
        const createButton = this.modal?.querySelector('[data-create-button]');
        if (createButton) {
            createButton.disabled = true;
        }

        this.modal.classList.remove('is-upload-ready');
        const uploadTitle = this.modal.querySelector('[data-upload-title]');
        if (uploadTitle) {
            uploadTitle.textContent = 'Качи снимка и виж избраната мебел в твоята стая';
        }

        // Defer ALL operations to next tick to break any potential recursion
        requestAnimationFrame(() => {
            try {
            // Show upload step
            this.showStep('upload');
            
            // Double-clear file input after RAF
            if (fileInput) {
                fileInput.value = '';
            }
            
            // Hide preview
            const preview = this.modal?.querySelector('[data-upload-preview]');
            if (preview) {
                preview.style.display = 'none';
            }
            
            // Hide errors
            const uploadError = this.modal?.querySelector('[data-upload-error]');
            if (uploadError) {
                uploadError.style.display = 'none';
                uploadError.textContent = '';
            }
            
            const resultError = this.modal?.querySelector('[data-result-error]');
            if (resultError) {
                resultError.style.display = 'none';
                resultError.textContent = '';
            }
            
            } catch (err) {
            console.error('❌ Error during reset:', err);
            } finally {
            // Reset flag after everything
            setTimeout(() => {
                this.isResetting = false;
            }, 300);
            }
        });
        }

        showStep(step) {
        // Prevent if modal doesn't exist
        if (!this.modal) {
            return;
        }
        
        // Prevent if already on this step
        if (this.currentStep === step) {
            return;
        }
        
        const steps = this.modal.querySelectorAll('[data-step]');
        if (steps) {
            steps.forEach(s => {
            s.style.display = s.dataset.step === step ? 'block' : 'none';
            });
        }
        this.currentStep = step;
        }

        handleFileSelect(e) {
        const file = e.target.files[0];
        if (file) {
            this.handleFile(file);
        }
        }

        handleFile(file) {
        // Validate file type
        if (!ALLOWED_TYPES.includes(file.type)) {
            this.showError('upload', 'Моля, изберете JPG или PNG файл.');
            return;
        }
        
        // Validate file size
        if (file.size > MAX_FILE_SIZE) {
            this.showError('upload', 'Файлът е твърде голям. Максимум 10MB.');
            return;
        }
        
        this.uploadedFile = file;
        this.hideError('upload');
        
        // Show preview
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
            const preview = this.modal?.querySelector('[data-upload-preview]');
            const previewImage = this.modal?.querySelector('[data-preview-image]');
            if (preview && previewImage) {
                previewImage.onerror = () => {
                previewImage.src = '';
                preview.style.display = 'none';
                this.modal?.classList.remove('is-upload-ready');
                };
                previewImage.src = e.target.result;
                preview.style.display = 'block';
                this.modal?.classList.add('is-upload-ready');
                const uploadTitle = this.modal?.querySelector('[data-upload-title]');
                if (uploadTitle) uploadTitle.textContent = 'Готови сме да преобразим стаята ти';
            }
            
            this.updateCreateButtonState();
            } catch (err) {
            console.warn('Error showing preview:', err);
            }
        };
        reader.onerror = () => {
            this.showError('upload', 'Грешка при четене на файла. Моля, опитайте отново.');
        };
        reader.readAsDataURL(file);
        }

        async createVisualization() {
        if (!this.uploadedFile || !this.workerUrl) {
            return;
        }

        this.syncSelectedVariant();
        
        // Switch to loading step
        this.showStep('loading');
        this.hideError('upload');
        
        // Prepare form data
        const formData = new FormData();
        formData.append('room_image', this.uploadedFile);
        formData.append('product_image_url', this.productImageUrl);
        formData.append('product_image_urls', JSON.stringify(this.productImageUrls));
        
        // Create abort controller for timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT);
        
        try {
            const response = await fetch(this.workerUrl, {
            method: 'POST',
            body: formData,
            signal: controller.signal
            });
            
            clearTimeout(timeoutId);
            
            if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `HTTP ${response.status}`);
            }
            
            const data = await response.json();
            
            if (!data.success || !data.image_data) {
            const errorMsg = data.message || data.raw || 'Не беше генерирана визуализация';
            console.error('API Error:', data);
            throw new Error(errorMsg);
            }
            
            // Show result
            this.generatedImage = data.image_data;
            this.showResult(data.image_data);
            
        } catch (error) {
            clearTimeout(timeoutId);
            
            let errorMessage = 'Възникна грешка при генериране на визуализацията. Моля, опитайте отново.';
            
            if (error.name === 'AbortError') {
            errorMessage = 'Заявката отне твърде много време. Моля, опитайте отново.';
            } else if (error.message) {
            errorMessage = error.message;
            }
            
            // Return to upload step with error
            this.showStep('upload');
            this.showError('upload', errorMessage);
        }
        }

        showResult(imageData) {
        this.showStep('result');
        
        const resultImage = this.modal.querySelector('[data-result-image]');
        if (resultImage) {
            resultImage.src = imageData;
        }
        }

        async addToCart() {
        this.syncSelectedVariant();
        if (!this.productVariantId) return;
        
        const addButton = this.modal.querySelector('[data-add-to-cart-button]');
        if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Добавяне...';
        }
        
        this.hideError('result');
        
        try {
            // Get quantity from product form
            const quantityInput = document.querySelector('#quantity');
            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
            
            // Prepare cart add request
            const formData = new FormData();
            formData.append('id', this.productVariantId);
            formData.append('quantity', quantity);
            
            // Get cart drawer/notification for sections
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cart && cart.getSectionsToRender) {
            formData.append('sections', cart.getSectionsToRender().map(s => s.id).join(','));
            formData.append('sections_url', window.location.pathname);
            }
            
            // Use theme's fetchConfig if available
            const config = typeof fetchConfig === 'function' ? fetchConfig('json') : {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
            };
            
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;
            
            // Get routes from window
            const routes = window.routes || {};
            const cartAddUrl = routes.cart_add_url || '/cart/add.js';
            
            const response = await fetch(cartAddUrl, config);
            
            if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || 'Грешка при добавяне в количката');
            }
            
        // Parse response (same as theme does)
        const result = await response.json();
        
        // Close modal first
        this.closeModal();
        
        // Update cart count (exact theme pattern)
        fetch('/cart.json')
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll('.cart-count').forEach((el) => {
                if (el.classList.contains('cart-count-drawer')) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector('header-total-price')) {
                document.querySelector('header-total-price').updateTotal(cart);
              }
              const cart_free_ship = document.querySelector('free-ship-progress-bar');
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            console.warn('Could not update cart count:', error);
          });
        
        // Get cart element (drawer or notification)
        const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        if (cartElement && !result.errors) {
          // Update cart sections (exact theme pattern from theme.js line 7128-7143)
          if (typeof cartElement.getSectionsToRender === 'function') {
            cartElement.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.getElementById(section.id);
              if (elementToReplace && result.sections && result.sections[section.id]) {
                const html = new DOMParser().parseFromString(
                  result.sections[section.id],
                  'text/html'
                );
                const minicartForm = html.querySelector('#minicart-form');
                if (minicartForm) {
                  elementToReplace.innerHTML = minicartForm.innerHTML;
                }
              }
            });
          }
          
          // Call cartAction if available (theme pattern)
          if (typeof cartElement.cartAction === 'function') {
            cartElement.cartAction();
          }
          
          // Remove is-empty class if present (theme pattern)
          if (cartElement.classList.contains('is-empty')) {
            cartElement.classList.remove('is-empty');
          }
          
          // Open cart (theme pattern)
          if (typeof cartElement.open === 'function') {
            cartElement.open();
          }
        }
            
        } catch (error) {
            let errorMessage = 'Възникна грешка при добавяне в количката. Моля, опитайте отново.';
            if (error.message) {
            errorMessage = error.message;
            }
            this.showError('result', errorMessage);
            
            if (addButton) {
            addButton.disabled = false;
            addButton.textContent = 'Добави в количка';
            }
        }
        }

        showError(step, message) {
        const errorElement = this.modal?.querySelector(`[data-${step}-error]`);
        if (errorElement) {
            errorElement.textContent = message;
            errorElement.style.display = 'block';
        }
        }

        hideError(step) {
        const errorElement = this.modal?.querySelector(`[data-${step}-error]`);
        if (errorElement) {
            errorElement.style.display = 'none';
            errorElement.textContent = '';
        }
        }

        updateCreateButtonState() {
        const createButton = this.modal?.querySelector('[data-create-button]');
        if (createButton) {
            createButton.disabled = !this.uploadedFile;
        }
        }

        syncSelectedVariant() {
        const variantInput = document.querySelector(
            'form[id^="product-form-"] input[name="id"], product-form input[name="id"]'
        );
        if (!variantInput?.value) return;

        this.productVariantId = String(variantInput.value);
        const productJson = document.querySelector('[data-product-json]');
        if (!productJson) return;

        try {
            const product = JSON.parse(productJson.textContent);
            // Use the complete product gallery in Shopify's original order.
            // The first/featured image remains the canonical product reference.
            let imageUrl = product.featured_image;
            if (imageUrl && imageUrl.startsWith('//')) imageUrl = `https:${imageUrl}`;
            const imageUrls = Array.isArray(product.images) ? product.images : [];
            this.productImageUrls = imageUrls
                .map((url) => (url?.startsWith('//') ? `https:${url}` : url))
                .filter(Boolean);
            if (imageUrl) {
                this.productImageUrl = imageUrl;
                this.productImageUrls = [
                    imageUrl,
                    ...this.productImageUrls.filter((url) => url !== imageUrl)
                ];
            }
        } catch (error) {
            console.warn('Visualization: Could not sync selected variant image', error);
        }
        }
        }

    // Initialize when DOM is ready
    // Use a global flag to prevent multiple script executions
    if (window.__visualizationInitialized) {
        return;
    }
    window.__visualizationInitialized = true;
    
    let visualizationInstance = null;
    
    function initVisualization() {
        // Prevent multiple initializations
        if (visualizationInstance) {
        return;
        }
        
        const button = document.querySelector('.product-visualization-button');
        if (!button) {
        return;
        }
        
        // Mark button to prevent double-init
        if (button.dataset.visualizationBound === 'true') {
        return;
        }
        button.dataset.visualizationBound = 'true';
        
        try {
        visualizationInstance = new RoomVisualization();
        } catch (err) {
        console.error('❌ Error initializing visualization:', err);
        button.dataset.visualizationBound = 'false';
        }
    }

    // Use a more robust initialization approach
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initVisualization, 100);
        });
    } else {
        // DOM already loaded, wait a bit to ensure all elements are ready
        setTimeout(initVisualization, 100);
    }
    })();
